<template>
  <div v-if="!createtype" class="sub-container flex wrap align-center">
    <!-- <div class="flex between align-center fill b16">
        <b>What would you like to create?</b>
        <i @click="$store.commit('closeAll')" class="fas fa-times p8" ></i>
      </div> -->
    <span v-for="(type, typeKey) in alloweditems" :key="typeKey">
      <a
        type="button"
        class="button p16 m8 flex align-center"
        @click="createtype = type.name"
        ><i class="fa fa-plus r4 fa-sm"></i>{{ type.name }}</a
      >
    </span>
    <!-- <select v-model="createtype">
        <option selected disabled>Create an item</option>
        <option
          :key="typeKey"
          :value="type.name"
          v-for="(type, typeKey) in alloweditems"
          class="flex column"
        >
            {{ type.name }}
        </option>
      </select> -->
  </div>
  <div v-else>
    <login v-if="!$store.state.auth.uid"></login>
    <keep-alive v-else>
      <component
        :id="'createitem_iform_' + (createtype.norm() || nType.norm())"
        :class="
          'flex column createitem_iform_' + (createtype.norm() || nType.norm())
        "
        style="height: 100%"
        v-if="
          $store.state.app.forms &&
          $store.state.app.forms[createtype.norm() || nType.norm()]
        "
        :is="'iform'"
        :title="true"
        :form-model="formModel"
        :submittext="
          (formModel && formModel.forms && formModel.forms.submittext) ||
          formModel.submit.method + ' ' + formModel.submit.type
        "
      ></component>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "new",
  computed: {
    alloweditems() {
      let newarr =
        this.$store.state.app.user.includes(this.$store.state.auth.uid) ||
        (this.$store.state.app.advanced.roles.admin &&
          this.$store.state.app.advanced.roles.admin.members &&
          this.$store.state.app.advanced.roles.admin.members.includes(
            this.$store.state.auth.uid
          ))
          ? this.$store.state.app.basics.items
          : this.$store.state.app.basics.items &&
            this.$store.state.app.basics.items.filter(
              (x) => x["crowd allowed"]
            );
      return newarr;
    },
    formModel() {
      if (!this.$store.state.app.forms[this.createtype]) return;
      let model = JSON.parse(
        JSON.stringify(this.$store.state.app.forms[this.createtype])
      );
      model.forms.map((x) => {
        x.inputs = x.inputs.filter((y) => y.display && y.display.form); // filtering if form allowed
        return x;
      });
      return model;
    },
  },
  data() {
    return {
      createtype: this.nType,
      showError: false,
    };
  },
  props: { nType: { type: String } },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.listing {
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  padding: 4px;
}
.flex-item {
  flex: 1 1 auto;
  margin: 8px;
}
.list-form {
  text-align: left;
  display: flex;
  flex-wrap: wrap;
}
.list-submit {
  margin-top: 16px;
}
.list-page {
  display: flex;
  flex-direction: column;
}
.listing textarea {
  font-size: 1.1em;
  min-height: 160px;
  height: 100%;
}
.listing input {
  margin-bottom: 8px;
}
.listing input[type="number"] {
  min-width: 64px;
  max-width: 96px;
  flex: 1 1 100%;
}
.newevent-img {
  max-width: 100%;
  object-fit: cover;
}

.section.start {
  justify-content: flex-start;
}
.disclaimer {
  text-align: left;
  padding: 16px;
}
</style>
